import { UPDATE_DISTRIBUTION_PARTNER_STATUS } from './distributorPartner.actionTypes';

export default function distributionPartner(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case UPDATE_DISTRIBUTION_PARTNER_STATUS:
            return {
                ...newState,
                status : action.status
            }
        default:
            return newState;
    }
}
